import type { PaginationQuery } from '../../../types/pagination';
import { appendPaginationQuery } from '../../../types/pagination';
import type { ApiClient } from '../client';
import type { CreatePurchaseRequisitionRequest, ListGrnsResponse, ListPurchaseInvoicesResponse, ListPurchaseOrdersResponse, ListPurchaseRequisitionsResponse, ListVendorPaymentsResponse, ListVendorsResponse, Uuid } from '../types';

export function bindProcurement(client: ApiClient) {
  return {
async listInventoryVendors() {
    return client.request<ListVendorsResponse>('/inventory/vendors');
  },

async createInventoryVendor(body: {
    name: string;
    contact_person?: string | null;
    phone?: string | null;
    email?: string | null;
    address?: string | null;
    gst_no?: string | null;
    status?: 'active' | 'inactive';
  }) {
    return client.request<{ vendor_id: Uuid }>('/inventory/vendors', {
      method: 'POST',
      body: JSON.stringify(body),
    });
  },

async listPurchaseRequisitions(params?: PaginationQuery) {
    const qs = new URLSearchParams();
    appendPaginationQuery(qs, params);
    const query = qs.toString();
    const path = query ? `/procurement/requisitions?${query}` : '/procurement/requisitions';
    return client.request<ListPurchaseRequisitionsResponse>(path);
  },

async createPurchaseRequisition(body: CreatePurchaseRequisitionRequest) {
    return client.request<{ requisition_id: Uuid }>('/procurement/requisitions', {
      method: 'POST',
      body: JSON.stringify(body),
    });
  },

async listPurchaseOrders(params?: PaginationQuery) {
    const qs = new URLSearchParams();
    appendPaginationQuery(qs, params);
    const query = qs.toString();
    const path = query ? `/procurement/purchase-orders?${query}` : '/procurement/purchase-orders';
    return client.request<ListPurchaseOrdersResponse>(path);
  },

async createPurchaseOrder(body: Record<string, unknown>) {
    return client.request<{ purchase_order_id: Uuid }>('/procurement/purchase-orders', {
      method: 'POST',
      body: JSON.stringify(body),
    });
  },

async listGrns(params?: PaginationQuery) {
    const qs = new URLSearchParams();
    appendPaginationQuery(qs, params);
    const query = qs.toString();
    const path = query ? `/procurement/grns?${query}` : '/procurement/grns';
    return client.request<ListGrnsResponse>(path);
  },

async createGrn(body: Record<string, unknown>) {
    return client.request<{ grn_id: Uuid }>('/procurement/grns', {
      method: 'POST',
      body: JSON.stringify(body),
    });
  },

async listPurchaseInvoices(params?: PaginationQuery) {
    const qs = new URLSearchParams();
    appendPaginationQuery(qs, params);
    const query = qs.toString();
    const path = query ? `/procurement/invoices?${query}` : '/procurement/invoices';
    return client.request<ListPurchaseInvoicesResponse>(path);
  },

async createPurchaseInvoice(body: Record<string, unknown>) {
    return client.request<{ invoice_id: Uuid }>('/procurement/invoices', {
      method: 'POST',
      body: JSON.stringify(body),
    });
  },

async listVendorPayments(params?: PaginationQuery) {
    const qs = new URLSearchParams();
    appendPaginationQuery(qs, params);
    const query = qs.toString();
    const path = query ? `/procurement/payments?${query}` : '/procurement/payments';
    return client.request<ListVendorPaymentsResponse>(path);
  },

async recordVendorPayment(body: Record<string, unknown>) {
    return client.request<{ payment_id: Uuid }>('/procurement/payments', {
      method: 'POST',
      body: JSON.stringify(body),
    });
  }
  };
}
